import { render, staticRenderFns } from "./TiendasColor.vue?vue&type=template&id=d90f581c"
import script from "./TiendasColor.vue?vue&type=script&lang=js"
export * from "./TiendasColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports